/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {ContactId, ContactInput} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getEditRepresentativeContactUrl = (id: string, contactId: ContactId) => {
  return `/api/v1/sales/representatives/${id}/contacts/${contactId}`;
};

/**
 * @summary Edit representative contact
 */
export const editRepresentativeContact = async (
  id: string,
  contactId: ContactId,
  contactInput: ContactInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditRepresentativeContactUrl(id, contactId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(contactInput),
  });
};

export const getRemoveRepresentativeContactUrl = (id: string, contactId: ContactId) => {
  return `/api/v1/sales/representatives/${id}/contacts/${contactId}`;
};

/**
 * @summary Remove representative contact
 */
export const removeRepresentativeContact = async (
  id: string,
  contactId: ContactId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveRepresentativeContactUrl(id, contactId), {
    ...options,
    method: "DELETE",
  });
};

export const getAddRepresentativeContactUrl = (id: string) => {
  return `/api/v1/sales/representatives/${id}/contacts`;
};

/**
 * @summary Add representative contact
 */
export const addRepresentativeContact = async (
  id: string,
  contactInput: ContactInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ContactId> => {
  return customFetch<ContactId>(getAddRepresentativeContactUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(contactInput),
  });
};
